import { CommonModule, Location } from '@angular/common';
import { Component, computed, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ModalNames } from 'src/app/common/modal.config';
import { ModalService } from 'src/app/services/modal.service';

const TRANSACTION_SUFFIX =  /(\/transaction(?:In)?completed|\/transactionExpired)(?:[?#].*)?$/i;

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.sass'
})
export class NotificationComponent implements OnInit {
  @Input() bodyText: string = '';

  public readonly modalNamesEnum = ModalNames;
  readonly isNotificationModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.Notification) ?? false);

  constructor (public readonly modalService: ModalService, private readonly location: Location, private readonly router: Router) {}

  ngOnInit() {
    const url = this.router.url;
    if (TRANSACTION_SUFFIX.test(url)) {
      this.modalService.openModal(ModalNames.Notification);
      this.location.replaceState(url.replace(TRANSACTION_SUFFIX, ''));
    }
  }
}
